import threedocean from './3docean.json'
import audiojungle from './audiojungle.json'
import codecanyon from './codecanyon.json'
import graphicriver from './graphicriver.json'
import photodune from './photodune.json'
import themeforest from './themeforest.json'
import videohive from './videohive.json'

export default {
  '3docean': threedocean,
  audiojungle,
  codecanyon,
  graphicriver,
  photodune,
  themeforest,
  videohive
}



// WEBPACK FOOTER //
// ./config/sites/studio-recommendations/index.js